import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ATA.DOCUMENTOS_ATA.ANEXOS.CRIAR](context, documentoComAnexo) {
		const { data } = await api.documentosAtaAnexo.criar(documentoComAnexo)
		return data
	},
}
